import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "reactstrap";
import CustomerDetails from "../CustomerDetails";
import BookingDetails from "./BookingDetails";
import DetailsMap from "../DetailsMap";
import AddNewButton from "../../Common/Component/AddNewButton";
import { useNavigate, useParams } from "react-router-dom";
import { FileText } from "react-feather";
import EditBookCab from "../BookingHistory/EditBookCab";
import DriverInformation from "../DriverInformation";
import {
  getBookingById
} from "../../../Services/Booking.service";
import { getCustomerDetails } from "../../../Services/Customer.service";
import SharedDataContext from "../../../_helper/SharedData";
import { getUserRole, showAlert } from "../../../Services/Shared.service";
import { Admin, Capture, Dispatch, ShiftInCharge, VendorAgent } from "../../../Data/SideMenu/RouteMapping";
import { assignDriverValidStatus } from "../../../Data/Booking/BookingHistory";
import BookingContext from "../../../_helper/Booking";
import AssignDriver from "../../Driver/AssignDriver";
import { getDriverDataByBookingNumber } from "../../../Services/Driver.service";
import BookEdit from "../BookingHistory/bookEdit";
const BookingInfo = () => {
  const userRole = getUserRole();
  const [assignDriverModal, setassignDriverModal] = useState(false);
  const toggleAssignDriverModal = () =>
    setassignDriverModal(!assignDriverModal);
  const { setShowApiLoader, cityData, airportData } =
    useContext(SharedDataContext);
  const { emptyCallback } = useContext(BookingContext);
  const [bookingModal, setBookingModal] = useState(false);
  const BookingModalToggle = () => setBookingModal(!bookingModal);
  const [ticketModal, setticketModal] = useState(false);
  const TicketModalToggle = () => setticketModal(!ticketModal);
  const { bookingId } = useParams();
  const [bookingObj, setBookingObj] = useState({});

  const [bookingList, setBookingList] = useState("booking_details");
  const history = useNavigate();
  const redirectTimeLogPage = () => {
    history(
      `${process.env.PUBLIC_URL}/booking/booking-info/time-log/${bookingObj?.megaCabsBookingNo}`
    );
  };

  const [driverDetails, setDriverDetails] = useState({});
  const [customerDetails, setCustomerDetails] = useState({});
  const [latLng, setLatLng] = useState({});
  useEffect(() => {
    setShowApiLoader(true);
    getBookingById(bookingId)
      .then((bookingRes) => {
        const data = bookingRes.data;
        console.log(data, "datadata");
        if (data) {
          setBookingObj(data);
          if (data?.custId > 0) {
            getCustomerDetails(data.custId)
              .then((customerResult) => {
                console.log(customerResult, "customerResult");
                setCustomerDetails(customerResult.data);
                setShowApiLoader(false);
              })
              .catch((err) => {
                setShowApiLoader(false);
                showAlert("error", "Something went wrong");
              });
          } else {
            setShowApiLoader(false);
          }
          if (data?.megaCabsBookingNo) {
            getDriverDataByBookingNumber(data.megaCabsBookingNo).then((driverResult) => {
              if (driverResult.data) {
                setDriverDetails(driverResult.data);
              }
            });
          }
        }
      })
      .catch((err) => {
        showAlert("error", "Something went wrong");
        setShowApiLoader(false);
      });
  }, []);
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col xs="12">
            <Row>
              <Col xl="4">
                <CustomerDetails
                  customerDetails={customerDetails}
                  tripObj={bookingObj}
                />
              </Col>
              <Col xl="8">
                {/* {Object.keys(bookingObj).length > 0 ? (
                  <DetailsMap bookingObj={bookingObj} />
                ) : (
                  ""
                )} */}
                <DetailsMap bookingObj={bookingObj} />
              </Col>
            </Row>
          </Col>
          <Col md="12">
            <Row className="trip-options">
              <div>
                <ul className="booking-tabs">
                  <li
                    className={`${
                      bookingList == "booking_details" ? "active" : ""
                    }`}
                    onClick={() => setBookingList("booking_details")}
                  >
                    Booking Details
                    <div className="arrow-down"></div>
                  </li>
                  <li
                    className={`${
                      bookingList == "driver_information" ? "active" : ""
                    }`}
                    onClick={() => setBookingList("driver_information")}
                  >
                    Driver Information
                    <div className="arrow-down"></div>
                  </li>
                </ul>
              </div>
              <div className="more-options">
                <div>
                  {userRole.some(
                    (element) =>
                      element == Dispatch ||
                      element == Admin ||
                      element == ShiftInCharge
                  ) &&
                  bookingObj &&
                  assignDriverValidStatus.includes(
                    bookingObj?.currentBookingStatusType
                  ) ? (
                    <AddNewButton
                      options={{
                        name: bookingObj?.driverId
                          ? "Reassign Driver"
                          : "Assign Driver",
                        icon: <i className="fa fa-user-plus"></i>,
                        title: "Assign Driver",
                        onclickEvent: toggleAssignDriverModal,
                      }}
                    >
                      <AssignDriver
                        LargeModaltoggle={toggleAssignDriverModal}
                        title={"Assign Driver"}
                        Large={assignDriverModal}
                        setShowApiLoader={setShowApiLoader}
                        assignDriverBookingObj={bookingObj}
                        onSubmitData={{ fetchBookingData: emptyCallback }}
                      />
                    </AddNewButton>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {userRole.some(
                    (element) =>
                      element == Capture ||
                      element == Admin ||
                      element == ShiftInCharge
                  ) ? (
                    <AddNewButton
                      options={{
                        name: "Re-book",
                        icon: <i className="fa fa-car"></i>,
                        onclickEvent: BookingModalToggle,
                      }}
                    >
                      {/* <EditBookCab
                        title={"Re-book"}
                        Large={bookingModal}
                        LargeModaltoggle={BookingModalToggle}
                        cityData={cityData}
                        airportData={airportData}
                        onSubmitData={{ fetchBookingData: emptyCallback }}
                        editType={"Rebook"}
                        bookingData={bookingObj}
                        setShowApiLoader={setShowApiLoader}
                      /> */}
                      <BookEdit
                        LargeModaltoggle={BookingModalToggle}
                        title={"Create a new booking"}
                        Large={bookingModal}
                        bookingData={bookingObj}
                        cityData={cityData}
                        airportData={airportData}
                        onSubmitData={{ fetchBookingData: emptyCallback }}
                        editType={"Rebook"}
                        setShowApiLoader={setShowApiLoader}
                      />
                    </AddNewButton>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  <AddNewButton
                    options={{
                      name: "Time log",
                      icon: <i className="fa fa-clock-o"></i>,
                      title: "Time log",
                      onclickEvent: redirectTimeLogPage,
                    }}
                  ></AddNewButton>
                </div>
                <div>
                  {bookingObj?.tripId && userRole.some((role) => role !== VendorAgent)? (
                    <AddNewButton
                      options={{
                        name: "Trip Detail",
                        icon: <i className="fa fa-map-marker"></i>,
                        title: "Trip Detail",
                        onclickEvent: () => {
                          history(
                            `${process.env.PUBLIC_URL}/trips/trip-info/${bookingObj?.tripId}`
                          );
                        },
                      }}
                    ></AddNewButton>
                  ) : null}
                </div>
              </div>
            </Row>

            {bookingList == "booking_details" ? (
              <BookingDetails bookingObj={bookingObj} />
            ) : (
              <DriverInformation driverDetails={driverDetails} />
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default BookingInfo;
